import { render, staticRenderFns } from "./SellerList.vue?vue&type=template&id=3c40a59b"
import script from "./SellerList.vue?vue&type=script&lang=js"
export * from "./SellerList.vue?vue&type=script&lang=js"
import style0 from "./SellerList.vue?vue&type=style&index=0&id=3c40a59b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports